import FormErrors from "@/components/FormErrors/FormErrors";
import { JSConn } from "@/utilities/js-conn";
import uuidv4 from "uuid/v4";
import { last as Rlast } from "ramda";
import VueScrollTo from "vue-scrollto";

export default {
  name: "workOrderTaskEditForm",
  props: {
    workOrderTaskId: String,
  },
  components: {
    FormErrors,
  },
  data() {
    return {
      hasTaskErrors: false,
      taskErrors: [],
      task: {
        id: "",
        name: "",
        description: "",
        start_date: null,
        completed_date: null,
        status: "pending",
      },
    };
  },
  created() {
    // find all the tasks for this work order
    // they should be in the store
    const STEP_SIZE = 200;
    let lastTask = Rlast(this.workOrderTasks);

    // for the situations when there isn't a last task
    if (!lastTask) {
      lastTask = {
        sort_order: 0,
      };
    }

    if (this.workOrderTaskId === "new") {
      this.task = {
        id: uuidv4(),
        name: "New",
        description: null,
        start_date: null,
        completed_date: null,
        status: "pending",
        sort_order: lastTask.sort_order + STEP_SIZE,
        user_id: null,
        work_order_id: this.workOrder.id,
      };
    } else {
      // load the task into the store
      // or retrieve it
      const woTask = this.workOrderTaskById(this.workOrderTaskId);
      this.task = {
        id: woTask.id,
        name: woTask.name,
        description: woTask.description,
        start_date: woTask.start_date,
        completed_date: woTask.completed_date,
        status: woTask.status,
        sort_order: woTask.sort_order,
        user_id: woTask.user_id,
      };
    }

    this.$nextTick(() => {
      VueScrollTo.scrollTo("#top-target");
      this.$refs.firstInput.select();
    });
  },
  computed: {
    workOrder: function() {
      return this.$store.getters.workOrder;
    },
    workOrderTasks: function() {
      return this.$store.getters.workOrderTasks;
    },
    workOrderTaskById: function() {
      return id => this.$store.getters.workOrderTaskById(id);
    },
  },
  methods: {
    submitTaskForm(evt) {
      evt.preventDefault();
      const jsConn = new JSConn();

      let storeDispatch;

      if (this.workOrderTaskId === "new") {
        storeDispatch = "createWorkOrderTask";
      } else {
        storeDispatch = "updateWorkOrderTask";
      }

      jsConn.formParams = this.task;

      this.$store
        .dispatch(storeDispatch, jsConn)
        .then(() => {
          // move to the list of tasks
          this.$router.push({
            name: "workOrderTasks",
          });
          // load the work order again
          this.$emit("tasksChanged");
        })
        .catch(jsConn => {
          this.hasTaskErrors = true;
          this.taskErrors = jsConn.error["response"]["data"];
        });
    },
  },
};
